module.exports = __webpack_public_path__ + "img/lear-logo.e4858345.jpg";